import { ParkingPageId } from '../../../../domain/pages/ParkingPageId';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { useValidationResultMemo } from './useValidationResultMemo';
import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';

export function useHasPersonalDetails() {
	const {
		booking: { personalDetails: customerDetails },
	} = useNewBookingStore();

	return !!customerDetails;
}

export function usePersonalDetailsValidation() {
	const isValid = useHasPersonalDetails();
	const redirectUrl = useUrlForPageId(ParkingPageId.NewBookingDetails);

	return useValidationResultMemo({
		isValid,
		redirectUrl,
	});
}
